import { render, staticRenderFns } from "./DialogueAction.vue?vue&type=template&id=51a518ec&scoped=true&"
import script from "./DialogueAction.vue?vue&type=script&lang=js&"
export * from "./DialogueAction.vue?vue&type=script&lang=js&"
import style0 from "./DialogueAction.vue?vue&type=style&index=0&id=51a518ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a518ec",
  null
  
)

export default component.exports